import { render, staticRenderFns } from "./TaskPeriodici.vue?vue&type=template&id=0e523e01&scoped=true&"
import script from "./TaskPeriodici.vue?vue&type=script&lang=js&"
export * from "./TaskPeriodici.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e523e01",
  null
  
)

export default component.exports